<div *ngIf="!aktiv.ugyfelId" class="ures">
  <ion-icon name="business-outline"></ion-icon>
  Először válassz ügyfelet.
</div>

<ng-container *ngIf="aktiv.ugyfelId">
  <div class="n-oldalfej">
    <h2>Könyvelés</h2>
    <span class="n-alcim">Egyszeres könyvvitel · naplófőkönyv</span>
    <div class="spacer"></div>
    <ion-button size="small" fill="outline" style="--color:#fff;--border-color:rgba(255,255,255,.6)" (click)="rendez()" title="A tételek sorszámának újrarendezése dátum szerint">
      <ion-icon slot="start" name="swap-vertical"></ion-icon>Sorszámok rendezése
    </ion-button>
  </div>

  <!-- KATA / átalányadó / alanyi adómentesség (AAM) keretfigyelés – több keret is lehet egyszerre -->
  <div *ngFor="let k of keretek" class="keret-sav" [class.tullepve]="k.tullepve">
    <ion-icon [name]="k.tullepve ? 'warning' : 'speedometer'"></ion-icon>
    <span><b>{{ keretCim(k) }}</b> ({{ aktiv.ev }}):</span>
    <span>Bevétel <b>{{ k.bevetel | number:'1.0-0' }} Ft</b><span *ngIf="k.keret"> / {{ k.keret | number:'1.0-0' }} Ft</span></span>
    <div class="keret-bar" *ngIf="k.szazalek != null"><div class="kitolt" [style.width.%]="k.szazalek > 100 ? 100 : k.szazalek"></div></div>
    <span *ngIf="k.szazalek != null"><b>{{ k.szazalek }}%</b></span>
    <span *ngIf="k.fennmarado != null && !k.tullepve">· még {{ k.fennmarado | number:'1.0-0' }} Ft</span>
    <span *ngIf="k.tullepve" class="neg"><b>{{ k.fajta === 'aam' ? 'Értékhatár túllépve!' : 'Keret túllépve!' }}</b></span>
  </div>

  <!-- ═════════════ A KÖNYVELŐ ABLAK ═════════════ -->
  <app-szerk-zar-sav *ngIf="szerk" [zar]="zarTetel"></app-szerk-zar-sav>
  <form class="kv" *ngIf="szerk" #urlap (keydown.enter)="enterTovabb($event)" (ngSubmit)="mentes(true)" autocomplete="off">
    <div class="kv-fej">
      <button type="button" class="kv-vissza" *ngIf="visszaUt" (click)="visszaNaplo(szerk.id)" title="Vissza a naplóhoz (mentés nélkül)"><ion-icon name="arrow-back"></ion-icon>Vissza a naplóhoz</button>
      <span class="kv-cim">{{ szerk.id ? 'Tétel módosítása' : 'Új tétel' }}</span>
      <span class="kv-sorszam" *ngIf="szerk.sorszam">{{ szerk.sorszam }}. tétel</span>
      <span class="kv-osa" *ngIf="szerk.osa_szamlaszam"><ion-icon name="cloud-done-outline"></ion-icon> OSA: {{ szerk.osa_szamlaszam }}</span>
      <span class="kv-osa" *ngIf="modositoPar" title="Mentéskor az eredetihez kötjük – a kettő együtt érvényes">
        <ion-icon name="link-outline"></ion-icon> Módosító számla → eredeti: {{ modositoPar.eredeti_szamlaszam }}</span>
      <ng-container *ngIf="szamlaKapcsolat">
        <button type="button" class="kv-osa kv-kapcsolat" *ngIf="szamlaKapcsolat.eredeti" (click)="kapcsoltNyit(szamlaKapcsolat.eredeti.eredeti_tetel_id)"
                title="Ez egy módosító számla – az eredetivel együtt érvényes. Kattintásra megnyílik az eredeti.">
          <ion-icon name="link-outline"></ion-icon> Módosítja: {{ szamlaKapcsolat.eredeti.eredeti_szamlaszam }}</button>
        <button type="button" class="kv-osa kv-kapcsolat" *ngFor="let m of szamlaKapcsolat.modositok" (click)="kapcsoltNyit(m.tetel_id)"
                [title]="m.tetel_id ? 'Módosító számla – kattintásra megnyílik' : '0 Ft-os módosító, könyvelés nélkül csatolva (' + m.csatolva + ')'">
          <ion-icon name="link-outline"></ion-icon> Módosítva: {{ m.szamlaszam }} ({{ +m.osszeg > 0 ? '+' : '' }}{{ m.osszeg | number:'1.0-2' }})</button>
      </ng-container>
      <label class="kv-osa kv-storno" *ngIf="stornoPar" title="A storno az eredeti tükreként könyvelődik: ugyanazok a rovatok negatív összeggel – 0 egyenleg">
        <input type="checkbox" [(ngModel)]="stornoParJelol" name="stornoParJelol">
        Sztornózva ({{ stornoPar.szamlaszam }}) – a storno is könyvelődjön vele</label>
      <div class="spacer"></div>
      <button type="button" class="kv-behuz" (click)="osaIndit()" title="Számla behúzása a NAV Online Számla rendszeréből – a lekérés automatikus">
        <ion-icon name="cloud-download-outline"></ion-icon>Számla behúzása (NAV)
      </button>
      <button type="button" class="kv-ikon" (click)="uj(); urlapFokusz()" title="Új, üres tétel"><ion-icon name="add"></ion-icon></button>
    </div>

    <div class="kv-felso">
      <!-- bal: dátumok, pénzforgalmi hely, egyenlegek -->
      <div class="kv-panel">
        <label class="kv-mezo"><span>Dátum</span><input type="date" name="datum" [(ngModel)]="szerk.datum" required></label>
        <label class="kv-mezo"><span>ÁFA esed.</span><input type="date" name="afaesed" [(ngModel)]="szerk.afa_esedekesseg"></label>
        <label class="kv-mezo"><span>Pénzforg.</span>
          <select name="penztar" [(ngModel)]="szerk.penztar_id">
            <option *ngFor="let p of penztarak" [ngValue]="p.id">{{ p.azonosito }} – {{ p.nev }}</option>
          </select>
        </label>
        <div class="kv-egyenleg">
          <span>Nyitó</span><b>{{ fmt0(nyitoEgyenleg) }}</b>
          <span>Záró</span><b [class.neg]="zaroEgyenleg < 0">{{ fmt0(zaroEgyenleg) }}</b>
        </div>
      </div>
      <!-- jobb: bizonylat, partner, megjegyzés, gyűjtő -->
      <div class="kv-panel">
        <label class="kv-mezo"><span>Bizonylatsz.</span>
          <span class="kv-egyutt">
            <input name="biz" [(ngModel)]="szerk.bizonylatszam" placeholder="pl. BLAHA-2026-12">
            <button type="button" class="kv-lep" (click)="bizonylatLep(1)" title="Következő szám"><ion-icon name="chevron-up"></ion-icon></button>
            <button type="button" class="kv-lep" (click)="bizonylatLep(-1)" title="Előző szám"><ion-icon name="chevron-down"></ion-icon></button>
            <button type="button" class="kv-gomb" (click)="kovetkezoBizonylat()" title="Az utolsó tétel bizonylatszámát lépteti">+1</button>
          </span>
        </label>
        <label class="kv-mezo"><span>Partner</span>
          <span class="kv-egyutt">
            <input name="partner" readonly [value]="szerk.partner_nev || ''" placeholder="– nincs –" (click)="partnerPickerNyit()" class="kv-valaszto">
            <button type="button" class="kv-gomb" (click)="partnerPickerNyit()" title="Partner választása"><ion-icon name="search"></ion-icon></button>
            <button type="button" class="kv-gomb" *ngIf="szerk.partner_id || szerk.partner_nev" (click)="partnerTorles()" title="Partner törlése"><ion-icon name="close"></ion-icon></button>
          </span>
        </label>
        <div class="kv-figyel" *ngIf="szerk.partnerHianyzik">
          Nincs a törzsben. <a (click)="osaPartnerLetrehoz()">Létrehozás „{{ szerk.partner_nev }}" néven</a>
        </div>
        <label class="kv-mezo"><span>Megjegyzés</span><input name="megj" [(ngModel)]="szerk.megjegyzes"></label>
        <label class="kv-mezo"><span>Gyűjtő</span>
          <select name="gyujto" [(ngModel)]="szerk.gyujto_id">
            <option [ngValue]="null">– nincs –</option>
            <option *ngFor="let g of gyujtok" [ngValue]="g.id">{{ g.kod }} – {{ g.nev }}</option>
          </select>
        </label>
      </div>
    </div>

    <!-- ROVATSOROK – korlátlan: az utolsó sor mindig üres, amint írsz bele, újabb nyílik -->
    <datalist id="rovatLista"><option *ngFor="let r of rovatok" [value]="r.rovatszam">{{ r.nev }}</option></datalist>
    <div class="kv-racs">
      <table class="n-racs">
        <thead><tr>
          <th style="width:34px">#</th><th style="width:110px">Rovatszám</th><th>Rovat</th><th style="width:96px">Irány</th>
          <th style="width:92px">ÁFA %</th><th style="width:86px">Bev.sor</th>
          <th class="num" style="width:130px">Nettó</th><th class="num cs-afa" style="width:110px">ÁFA</th><th class="num" style="width:130px">Bruttó</th><th style="width:36px"></th>
        </tr></thead>
        <tbody>
          <tr *ngFor="let s of szerk.sorok; let i = index" [class.ures-sor]="i === szerk.sorok.length - 1">
            <td class="kv-ssz">{{ i + 1 }}.</td>
            <td><input class="kv-cella kod" [name]="'rsz' + i" [(ngModel)]="s.rovatszam" (ngModelChange)="rovatTukor(s)" list="rovatLista"
                       [class.jo]="s.talalt" [class.rossz]="s.rovatszam && s.talalt === false" placeholder="rovat"></td>
            <td class="kv-nev">
              <select class="kv-cella" [name]="'rov' + i" [(ngModel)]="s.rovat_id" (ngModelChange)="rovatValt(s)">
                <option [ngValue]="null">{{ s.rovatszam && s.talalt === false ? 'nincs ilyen rovat' : '–' }}</option>
                <option *ngFor="let r of rovatok" [ngValue]="r.id">{{ r.rovatszam }} – {{ r.nev }}</option>
              </select>
            </td>
            <td><select class="kv-cella" [name]="'ir' + i" [(ngModel)]="s.irany" (ngModelChange)="bevSorElotolt(s)">
              <option value="bevetel">Bevétel</option><option value="kiadas">Kiadás</option></select></td>
            <td><select class="kv-cella" [name]="'afa' + i" [(ngModel)]="s.afa_kulcs" (ngModelChange)="szamol(s); bevSorElotolt(s)">
              <option [ngValue]="null">–</option>
              <option *ngFor="let k of opciok.afaKulcsok" [ngValue]="k">{{ k }}%</option></select></td>
            <td><span class="kv-egyutt"><input class="kv-cella" [name]="'bs' + i" [(ngModel)]="s.bevallas_sor" placeholder="—" [title]="bevTanultCim(s)" [class.bevsor-tanult-mezo]="bevTanultLatszik(s)">
              <button type="button" class="kv-mini" (click)="bevsorNyit(s, 'bevallas_sor')" title="Bevallási sor kiválasztása a törzsből"><ion-icon name="list-outline"></ion-icon></button></span></td>
            <td class="num"><input class="kv-cella num" type="number" step="0.01" [name]="'n' + i" [(ngModel)]="s.netto" (blur)="szamol(s)"></td>
            <td class="num cs-afa"><input class="kv-cella num" type="number" step="0.01" [name]="'a' + i" [(ngModel)]="s.afa" readonly tabindex="-1"></td>
            <td class="num"><input class="kv-cella num" type="number" step="0.01" [name]="'b' + i" [(ngModel)]="s.brutto" (blur)="szamol(s)"></td>
            <td><button type="button" class="kv-torol" *ngIf="i < szerk.sorok.length - 1" (click)="torolSor(i)" title="Sor törlése"><ion-icon name="close"></ion-icon></button></td>
          </tr>
        </tbody>
        <tfoot><tr>
          <td colspan="6" class="kv-ossz-cim">ÖSSZESEN <span class="halvany">({{ kitoltottSorok.length }} sor; a kiadás negatív)</span></td>
          <td class="num">{{ fmt0(sorOsszeg('netto')) }}</td><td class="num cs-afa">{{ fmt0(sorOsszeg('afa')) }}</td><td class="num">{{ fmt0(sorOsszeg('brutto')) }}</td><td></td>
        </tr></tfoot>
      </table>
    </div>

    <div class="kv-lab">
      <ion-button type="button" size="small" fill="outline" color="warning" *ngIf="szerk.nav_pdf_id" (click)="navPdfMegnyit(szerk.nav_pdf_id)"><ion-icon slot="start" name="reader"></ion-icon>NAV PDF</ion-button>
      <ion-button type="button" size="small" fill="outline" color="tertiary" *ngIf="szerk.dok_pdf_id" (click)="dokPdfMegnyit(szerk.dok_pdf_id)"><ion-icon slot="start" name="folder-open"></ion-icon>Dokumentum</ion-button>
      <ion-button type="button" size="small" fill="outline" *ngIf="szerk.osa_szamlaszam || szerk.kep_nev" (click)="nyitSzamlaKep()"><ion-icon slot="start" name="document-text"></ion-icon>Számlakép</ion-button>
      <ng-container *ngIf="szerk.id">
        <input #kepInput type="file" accept="image/*,application/pdf" hidden (change)="kepFeltolt($event)">
        <ion-button type="button" size="small" fill="clear" (click)="kepInput.click()" title="Számlakép feltöltése"><ion-icon slot="icon-only" name="cloud-upload"></ion-icon></ion-button>
        <ion-button type="button" size="small" fill="clear" *ngIf="szerk.kep_nev" (click)="kepMegnyit()" title="Számlakép megnyitása"><ion-icon slot="icon-only" name="eye"></ion-icon></ion-button>
      </ng-container>
      <ion-button type="button" size="small" fill="outline" *ngIf="szerk.id" (click)="hozamTetel = szerk.id"
                  title="A bizonylat (vagy egyes sorai) egy tárgyi eszköz bérleti díja vagy kiadása – a megtérülési kimutatáshoz"><ion-icon slot="start" name="construct-outline"></ion-icon>Tárgyi eszközhöz</ion-button>
      <div class="spacer"></div>
      <div class="kv-egyenlegek">
        <span>Bank <b [class.neg]="bankEgyenleg < 0">{{ fmt0(bankEgyenleg) }}</b></span>
        <span>Pénztár <b [class.neg]="penztarEgyenleg < 0">{{ fmt0(penztarEgyenleg) }}</b></span>
      </div>
      <ion-button type="button" size="small" fill="outline" (click)="kerekites()" title="Egész forintra kerekít">Kerekítés</ion-button>
      <ion-button type="button" size="small" fill="outline" color="danger" *ngIf="szerk.id" [disabled]="zarTilt" (click)="torol(szerk)">Törlés</ion-button>
      <ion-button type="submit" size="small" [disabled]="zarTilt"><ion-icon slot="start" name="save-outline"></ion-icon>Mentés / Új tétel</ion-button>
    </div>
  </form>

  <!-- ═════════════ AZ ÉV TÉTELEI ═════════════ -->
  <div class="n-szuro-sor">
    <label>Tételek ({{ aktiv.ev }})</label>
    <input type="search" name="szuro" [(ngModel)]="szuro" placeholder="Partner, bizonylat, megjegyzés, sorszám…" style="flex:1;min-width:220px">
    <span class="halvany">{{ szurtTetelek.length }} / {{ tetelek.length }}</span>
  </div>
  <div class="ures" *ngIf="!tetelek.length"><ion-icon name="create-outline"></ion-icon>Még nincs könyvelt tétel ebben az évben ({{ aktiv.ev }}).</div>
  <div class="tabla-wrap kv-lista" *ngIf="tetelek.length">
    <table class="n-racs">
      <thead><tr>
        <th class="num">#</th><th>Dátum</th><th>Bizonylat</th><th>Partner</th><th>Megjegyzés</th><th>Pénzforg.</th>
        <th class="num">Bevétel</th><th class="num">Kiadás</th><th></th>
      </tr></thead>
      <tbody>
        <tr *ngFor="let t of szurtTetelek" [class.kijelolt]="t.id === szerk?.id" (click)="szerkeszt(t)" style="cursor:pointer" title="Megnyitás szerkesztésre">
          <td class="num">{{ t.sorszam }}</td><td>{{ t.datum }}</td><td>{{ t.bizonylatszam }}</td><td>{{ t.partner_nev }}</td>
          <td class="halvany">{{ t.megjegyzes }}</td><td class="halvany">{{ t.penztar_azon }}</td>
          <td class="num">{{ t.bevetel ? fmt0(t.bevetel) : '' }}</td>
          <td class="num">{{ t.kiadas ? fmt0(t.kiadas) : '' }}</td>
          <td (click)="$event.stopPropagation()">
            <button type="button" class="kv-torol" (click)="torol(t)" [disabled]="t.id === szerk?.id && zarTilt" title="Törlés"><ion-icon name="trash-outline"></ion-icon></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>

<!-- OSA számlaválasztó -->
<!-- SZÁMLA BEHÚZÁSA A NAV-BÓL – közös választó (osa-valaszto), a kettős könyveléssel azonos.
     Megnyitáskor a tárolt számlák látszanak, a NAV-lekérés automatikusan indul a háttérben. -->
<ion-modal #osaModal cssClass="naplo-wide-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej">
      <ion-title>Számla behúzása a NAV-ból (Online Számla)</ion-title>
      <ion-buttons slot="end"><ion-button (click)="osaModal.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content>
      <app-naplo-osa-valaszto #osaValaszto [ugyfelId]="aktiv.ugyfelId" [ev]="aktiv.ev" [tomeges]="true"
        (konyvel)="osaValasztKonyvel($event)" (csatol)="osaCsatol($event)" (tomegesKonyvel)="osaTomeges($event)" (kep)="osaSzamlakep($event)">
      </app-naplo-osa-valaszto>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- Kereshető partner-választó -->
<ion-modal #partnerPickerModal class="kozep-modal">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo); --color:#fff">
      <ion-title>Partner kiválasztása</ion-title>
      <ion-buttons slot="end"><ion-button (click)="partnerPickerModal.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content>
      <ion-searchbar placeholder="Keresés név vagy adószám szerint…" [(ngModel)]="partnerKereso" [debounce]="150"></ion-searchbar>
      <ion-list>
        <ion-item button *ngFor="let p of szurtPartnerek" (click)="partnerValaszt(p)">
          <ion-label>
            <h3>{{ p.rovid_nev || p.nev }}</h3>
            <p *ngIf="p.rovid_nev && p.nev !== p.rovid_nev">{{ p.nev }}</p>
            <p *ngIf="p.adoszam">Adószám: {{ p.adoszam }}</p>
          </ion-label>
        </ion-item>
        <ion-item *ngIf="!szurtPartnerek.length" lines="none">
          <ion-label color="medium">Nincs találat.</ion-label>
        </ion-item>
      </ion-list>
      <div class="ion-padding" *ngIf="partnerKereso.trim()">
        <ion-button expand="block" fill="outline" (click)="partnerLetrehoz()">
          <ion-icon slot="start" name="add"></ion-icon> Új partner: „{{ partnerKereso }}"
        </ion-button>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- ═══ BEVALLÁSI SOR KIVÁLASZTÁSA (törzsből, mint a főkönyvi szám) ═══ -->
<ion-modal [isOpen]="!!bevsorCel" (didDismiss)="bevsorCel = null" cssClass="bevsor-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Bevallási sor kiválasztása</ion-title></ion-toolbar></ion-header>
    <div class="bv-torzs">
      <app-naplo-bevsor-valaszto [aktualis]="bevsorCel ? bevsorCel.obj[bevsorCel.mezo] : null"
        (valaszt)="bevsorValaszt($event)" (megse)="bevsorCel = null"></app-naplo-bevsor-valaszto>
    </div>
  </ng-template>
</ion-modal>

<!-- Könyvelt bizonylat kötése egy tárgyi eszközhöz (bérleti díj / nem aktivált kiadás) -->
<ion-modal [isOpen]="!!hozamTetel" (didDismiss)="hozamTetel = null" class="ber-urlap-modal" cssClass="ber-urlap-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Tárgyi eszközhöz rendelés</ion-title>
      <ion-buttons slot="end"><ion-button (click)="hozamTetel = null">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <app-eszkoz-hozam-kotes [ugyfelId]="aktiv.ugyfelId" [tetelId]="hozamTetel" (kesz)="hozamKesz()"></app-eszkoz-hozam-kotes>
    </div>
  </ng-template>
</ion-modal>
